import React, { useEffect, useState } from "react";
import "./AnnuaireAlumniSearchBar.scss";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { FaSearch } from "react-icons/fa";
import { Checkbox } from "primereact/checkbox";
import PropTypes from "prop-types";
import iconeParrainage from "assets/iconeParrainage.png";
import { connect } from "react-redux";
import { useFetchGet, useFetchGetConditional } from "Services/api";
import Localisation from "Components/Localisation/Localisation";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";

const AnnuaireAlumniSearchBar = (props) => {
  // données qui seront en props pour la recherche
  const [motscles, setMotscles] = useState("");
  const [entreprise, setEntreprise] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [secteur, setSecteur] = useState([]);
  const [composante, setComposante] = useState([]);
  const [formation, setFormation] = useState([]);
  const [mentor, setMentor] = useState(false);
  const [createur, setCreateur] = useState(false);
  const [localisation, setLocalisation] = useState("");
  const [isVisibleLocation, setIsVisibleLocation] = useState(false);

  const formationData = useFetchGetConditional(
    "/domains",
    props.auth.token,
    props.secondaryTables.domainsData
  );
  const composanteData = useFetchGetConditional(
    "/education_composantes",
    props.auth.token,
    props.secondaryTables.educationComposanteData
  );
  const secteurData = useFetchGetConditional(
    "/sector_of_offers",
    props.auth.token,
    props.secondaryTables.sectorOfOffersData
  );
  const localisationData = useFetchGet(
    "/users/liste_localisation",
    props.auth.token
  );

  useEffect(() => {
    formationData.loaded &&
      composanteData.loaded &&
      secteurData.loaded &&
      props.handleUpdateSecondaryTables({
        domainsData: formationData.data,
        educationComposanteData: composanteData.data,
        sectorOfOffersData: secteurData.data,
      });
  }, [formationData.loaded, composanteData.loaded, secteurData.loaded]);
  // traitement de la recherche
  const [isSearched, setIsSearched] = useState(false);
  const setRecherche = () => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/users/annuaire`);
    url.searchParams.set("datasVisibleForAllMembers", 1);
    url.searchParams.set("role", "alumni");

    if (motscles != "") url.searchParams.set("keyword", motscles);
    if (entreprise != "")
      url.searchParams.set("resume.experiences.company", entreprise);
    if (nom != "") url.searchParams.set("surname", nom);
    if (prenom != "") url.searchParams.set("firstname", prenom);
    if (localisation != "") url.searchParams.set("localisation", localisation);
    if (mentor) url.searchParams.set("mentorAccept[]", 1);
    if (createur) url.searchParams.set("companyCreator[]", 1);

    if (composante) {
      composante.forEach((item) =>
        url.searchParams.append("composante[]", item.id)
      );
    }
    if (secteur) {
      secteur.forEach((item) =>
        url.searchParams.append("resume.experiences.sector[]", item.id)
      );
    }
    if (formation) {
      formation.forEach((item) => url.searchParams.append("domain[]", item.id));
    }

    if (
      motscles === "" &&
      entreprise === "" &&
      nom === "" &&
      prenom === "" &&
      localisation === "" &&
      !secteur &&
      !formation &&
      !composante &&
      !mentor &&
      !createur
    ) {
      setIsSearched(false);
    }
    props.setUrlAnnuaire(url);
  };
  return (
    <div className="annuaire_search_bar etudiant_bar">
      {/* <h2 className="annuaire_search_bar__title">Trouvez un alumni</h2> */}
      <div className="annuaire_search_bar__container">
        <div className="annuaire_search_bar__container__top">
          <div className="annuaire_search_bar__container__top__boxes">
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">MOTS CLÉS</label>
              <span className="annuaire_p-input-icon-left">
                <InputText
                  value={motscles}
                  onChange={(e) => setMotscles(e.target.value)}
                  placeholder=" Poste, Entreprise..."
                  className="box__input"
                />
              </span>
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">PRÉNOM</label>
              <InputText
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
                placeholder=" Alex, Emma, Julie"
                className="box__input"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">NOM</label>
              <InputText
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                placeholder=" Lebon, Dupont"
                className="box__input"
              />
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box input_localisation_annuaire">
              <label className="label-annuaire">LOCALISATION</label>
              <InputText
                value={localisation}
                onChange={(e) => {
                  setLocalisation(e.target.value);
                  if (e.target.value.length > 2) {
                    setIsVisibleLocation(true);
                  } else {
                    setIsVisibleLocation(false);
                  }
                }}
                placeholder=" Pays, ville"
                className="box__input"
              />
              {isVisibleLocation && localisationData.loaded && (
                <Localisation
                  location={localisation}
                  listOfData={localisationData.data}
                  btnAction={(element) => {
                    setLocalisation(element.toLowerCase());
                  }}
                  setIsVisibleLocation={setIsVisibleLocation}
                ></Localisation>
              )}
            </div>
            <Divider layout="vertical" />
            <div className="annuaire_search_bar__container__top__boxes__box">
              <label className="label-annuaire">ENTREPRISE</label>
              <InputText
                value={entreprise}
                onChange={(e) => setEntreprise(e.target.value)}
                placeholder=" Darty, Lactalis"
                className="box__input"
              />
            </div>
          </div>
          <div
            className="annuaire_search_bar__container__top__inputSearch not_mobile"
            onClick={() => {
              setIsSearched(true);
              setRecherche();
            }}
          >
            <FaSearch />
          </div>
        </div>
        <div className="annuaire_search_bar__container__bottom">
          <ul>
            <li>
              <label className="label-annuaire">Secteur d&apos;activité</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={secteur}
                options={secteurData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setSecteur(e.value)}
                optionLabel="label"
                placeholder="Secteur d'activité"
                maxSelectedLabels={3}
                selectedItemsLabel={`${secteur.length} options sélectionnées`}
                className="box__input"
              />
            </li>
            <li>
              <label className="label-annuaire">Composante</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={composante}
                options={composanteData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setComposante(e.value)}
                optionLabel="label"
                placeholder="Composante"
                maxSelectedLabels={3}
                className="box__input"
                selectedItemsLabel={`${composante.length} options sélectionnées`}
              />
            </li>
            <li>
              <label className="label-annuaire">Formation</label>
              <MultiSelect
                appendTo={document.getElementById("app")}
                value={formation}
                options={formationData.data?.sort((a, b) =>
                  a.label.localeCompare(b.label)
                )}
                onChange={(e) => setFormation(e.value)}
                optionLabel="label"
                placeholder="Formation"
                maxSelectedLabels={1}
                selectedItemsLabel={`${formation.length} options sélectionnées`}
                className="box__input"
              />
            </li>
            <li className="li_checkbox">
              <Checkbox
                id="cb1"
                checked={mentor}
                onChange={(e) => setMentor(e.checked)}
              ></Checkbox>
              <label htmlFor="cb1" className="p-checkbox-label">
                <img src={iconeParrainage} alt="" /> Parrain / Marraine
              </label>
            </li>
            <li className="li_checkbox">
              <Checkbox
                id="cb1"
                checked={createur}
                onChange={(e) => setCreateur(e.checked)}
              ></Checkbox>
              <label htmlFor="cb1" className="p-checkbox-label">
                <i className="pi pi-fw pi-building buildingLogoAnnuaire" />
                Créateur d&apos;entreprise
              </label>
            </li>
            {isSearched && (
              <li className="search_bar_refresh search_bar_refresh__annuaireEntreprise">
                <i
                  className="pi pi-refresh"
                  style={{ fontSize: "1.5rem", fontWeight: "600" }}
                  onClick={() => {
                    setIsSearched(false);
                    setFormation([]);
                    setEntreprise("");
                    setLocalisation("");
                    setMotscles("");
                    setNom("");
                    setPrenom("");
                    setComposante([]);
                    setSecteur([]);
                    let url = new URL(
                      `${process.env.REACT_APP_BASE_URL_API}/users/annuaire`
                    );
                    url.searchParams.set("datasVisibleForAllMembers", 1);
                    url.searchParams.set("role", "alumni");
                    props.setUrlAnnuaire(url);
                  }}
                />
              </li>
            )}
          </ul>
        </div>
        <div
          className="annuaire_search_bar__container__top__inputSearch not_desktop"
          onClick={() => {
            setIsSearched(true);
            setRecherche();
          }}
        >
          <FaSearch />
        </div>
      </div>
    </div>
  );
};

AnnuaireAlumniSearchBar.propTypes = {
  setUrlAnnuaire: PropTypes.func,
  auth: PropTypes.object,
  secondaryTables: PropTypes.object,
  handleUpdateSecondaryTables: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});
const mapDispatchToProps = (dispatch) => ({
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnuaireAlumniSearchBar);
